import { ReactComponent as FlagIcon } from "./svg/au-flag.svg";
import "../flag-icon.scss";

export const AUFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
